/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import PropTypes from 'prop-types'
import autoBind from 'react-autobind'

import Chip from 'material-ui/Chip'

export default class DefaultSelectionRenderer extends React.Component {
  constructor (props) {
    super(props)

    autoBind(this)
  }

  renderChip (value, index) {
    return (
      <Chip
        key={value[this.props.valueKey]}
        style={styles.chip}
        labelStyle={styles.label}
        onRequestDelete={() => this.props.deleteValue(this.props.name, value[this.props.valueKey])}
      >
        {
          value[this.props.textKey]
        }
      </Chip>
    )
  }

  render () {
    return (
      <div style={styles.wrapper}>
        {
          this.props.values.map(this.renderChip)
        }
      </div>
    )
  }
}

const styles = {
  chip: {
    margin: 4,
    maxWidth: '95%'
  },
  label: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: 128,
    overflowY: 'auto'
  }
}

DefaultSelectionRenderer.propTypes = {
  values: PropTypes.array,
  deleteValue: PropTypes.func,
  textKey: PropTypes.string,
  valueKey: PropTypes.string,
  name: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/generic/form/DefaultSelectionRenderer.js